<template>
    <MasterDetail
      ref="masterDetail"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      :opts="opts"
      :cols="cols"
      :canEdit="false"
      :canDelete="false"
      :hasNewButton="false"
      :customResource="customResource">
    </MasterDetail>
</template>

<script>
import MasterDetail from '@/components/master-detail.vue';
import { mapGetters } from 'vuex';
import rxoService from '@/api/ativacaoped/rxo.service';
import { createServiceResource } from '@/api/ativacaoped/resource-adapter';

export default {
    // props: {},
    components: {
        MasterDetail,
    },
    // mixins: [],
    // directives: {},
     data() {
         return {
           opts: {
             statusRubrica: [
               {
                 id: 1,
                 value: 'Ativo'
               },
               {
                 id: 0,
                 value: 'Inativo'
               },
             ],
            },
         }
     },
    computed: {
      ...mapGetters(['clientId']),
      cols() {
        return [
          {
            key: 'id',
            name: 'Código',
            hideInform: true,
            hideInTable: true,
            width: '50px',
          },
          {
            key: 'colaborador',
            name: 'Colaborador',
            type: this.$fieldTypes.TEXT,
            rules: [{ rule: 'required' }],
          },
          {
            key: 'bp',
            name: 'BP',
            type: this.$fieldTypes.TEXT,
            rules: [{ rule: 'required' }],
          },
          {
            key: 'versao_oficial',
            name: 'Versão oficial',
            type: this.$fieldTypes.TEXT,
          },
          {
            key: 'realizado',
            name: 'Realizado',
            type: this.$fieldTypes.TEXT,
          },
          {
            key: 'rxo',
            name: 'RxO',
            type: this.$fieldTypes.TEXT,
          },
          {
            key: 'justificativa',
            name: 'Justificativa',
            type: this.$fieldTypes.TEXT,
          },
        ]
      },
      /**
       * Resource service-backed consumido pelo `MasterDetail` apenas para a
       * listagem (`get`). A tela é somente leitura (`:canEdit="false"`,
       * `:canDelete="false"`, `hasNewButton=false`).
       * Substitui o `:resourceUrl`, que usava o `apiResource` inline do mixin.
       *
       * @returns {Object} Resource no contrato do `apiResource`
       */
      customResource() {
        // Ver nota em `divisoes.vue`: ler `clientId` aqui mantém o reload da grid
        // pelo watcher de `customResource` do `MasterDetail`.
        const clientId = this.clientId;

        return createServiceResource({
          notify: this.notify,
          get: ({ query }) => rxoService.getRxoAnalise(clientId, query)
        });
      },
    },
    // filters: {},
    // created() {},
    // mounted() {},
    // updated() {},
    // destroyed() {},
     methods: {
     },
    // watch: {},
}
</script>

<style>

</style>
